import { Fragment as _Fragment, jsx as _jsx } from "react/jsx-runtime";
import { translate } from '../../utils';
export const Translate = ({ label, dictionary, locale, useFallback = true }) => {
    return _jsx(_Fragment, { children: translate(label, dictionary, locale, useFallback) });
};
